export default __webpack_public_path__ + "static/media/history.76f4d5a8.svg";